module.exports = __webpack_public_path__ + "static/media/udemy logo.02b21939.png";